/**
 * Majahma subscription helpers
 * ----------------------------------------------------------------------------
 * Shared by the homepage CTA, sides step and cart customisation hub.
 *
 * Design principles:
 * - The Majahma Dinner anchor product is deterministic.
 * - Matching frequency does NOT mean matching selling_plan ID; every product has
 *   its own Recharge selling plan IDs.
 * - Prefer the known Recharge export map, then fall back to Shopify's live
 *   product JSON by correctly joining variant.selling_plan_allocations to
 *   product.selling_plan_groups[].selling_plans[].
 */
(function () {
  'use strict';

  var TIFFIN = {
    productId: '8214229024982',
    handle: 'majahma-tiffin-meal',
    variants: {
      Vegetarian: 44625396859094,
      Vegan: 44625396924630
    },
    plans: {
      // Shopify external selling plan IDs, not Recharge's internal plan IDs.
      every_week: 712471249273,
      every_2_weeks: 712471347577,
      every_4_weeks: 712471380345
    }
  };

  var SIDE_PLANS = {
    // Shopify external selling plan IDs by product handle. Recharge's export also
    // includes internal Plan IDs; those are converted via INTERNAL_TO_SHOPIFY_PLAN.
    'samosa-with-ambli-x-2':   { every_week: 712472428921, every_2_weeks: 712472396153, every_4_weeks: 712472461689 },
    'bhajia-bites':            { every_week: 712471642489, every_2_weeks: 712471675257, every_4_weeks: 712471609721 },
    'bhatura-x-2-3-00':        { every_week: 712472002937, every_2_weeks: 712472035705, every_4_weeks: 712472068473 },
    'green-chutney':           { every_week: 712472101241, every_2_weeks: 712472166777, every_4_weeks: 712472134009 },
    'lime-pickle-1':           { every_week: 712472199545, every_2_weeks: 712472232313, every_4_weeks: 712472265081 },
    'chapatti-x-2':            { every_week: 712472363385, every_2_weeks: 712472297849, every_4_weeks: 712472330617 },
    'chakri':                  { every_week: 712472494457, every_2_weeks: 712472527225, every_4_weeks: 712472658297 },
    'doonghri':                { every_week: 712472691065, every_2_weeks: 712472723833, every_4_weeks: 712472756601 },
    'papaddoms-x-2':           { every_week: 712472789369, every_2_weeks: 712472822137, every_4_weeks: 712472854905 },
    'tamarind-chutney':        { every_week: 712472887673, every_2_weeks: 712472920441, every_4_weeks: 712472985977 },
    'homemade-mango-chutney':  { every_week: 712473018745, every_2_weeks: 712472953209, every_4_weeks: 712473051513 },
    'thelpa-flatbread-2-00':   { every_week: 712473084281, every_2_weeks: 712473117049, every_4_weeks: 712473149817 },
    'punjabi-samosa':          { every_week: 712473182585, every_2_weeks: 712473215353, every_4_weeks: 712473248121 }
  };

  var SIDE_HANDLES = Object.keys(SIDE_PLANS);

  // Recharge internal Plan ID -> Shopify external selling_plan ID. Theme settings
  // and older metafields may still contain the internal 218xxxxx values; Shopify's
  // cart/add.js and cart/change.js require the external 712xxxxx selling_plan IDs.
  var INTERNAL_TO_SHOPIFY_PLAN = {
    21864223: 712471249273,
    21866728: 712471347577,
    21867018: 712471380345,
    21872273: 712472428921,
    21872275: 712472396153,
    21872276: 712472461689,
    21869540: 712471642489,
    21869539: 712471675257,
    21869538: 712471609721,
    21871084: 712472002937,
    21871085: 712472035705,
    21871086: 712472068473,
    21871682: 712472101241,
    21871683: 712472166777,
    21871684: 712472134009,
    21871687: 712472199545,
    21871689: 712472232313,
    21871690: 712472265081,
    21872267: 712472363385,
    21872268: 712472297849,
    21872269: 712472330617,
    21872279: 712472494457,
    21872280: 712472527225,
    21872282: 712472658297,
    21873312: 712472691065,
    21873313: 712472723833,
    21873315: 712472756601,
    21873317: 712472789369,
    21873319: 712472822137,
    21873320: 712472854905,
    21873322: 712472887673,
    21873323: 712472920441,
    21873324: 712472985977,
    21873325: 712473018745,
    21873327: 712472953209,
    21873328: 712473051513,
    21873331: 712473084281,
    21873332: 712473117049,
    21873334: 712473149817,
    21873335: 712473182585,
    21873336: 712473215353,
    21873337: 712473248121
  };

  function routeRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function endpoint(path) {
    var root = routeRoot();
    var clean = String(path || '').replace(/^\/+/, '');
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + clean;
  }

  function toInt(value) {
    if (value === null || value === undefined || value === '') return null;
    var n = parseInt(value, 10);
    return isNaN(n) ? null : n;
  }

  function normalisePlanId(value) {
    var n = toInt(value);
    if (!n) return null;
    return INTERNAL_TO_SHOPIFY_PLAN[n] || n;
  }

  function normaliseFrequency(value) {
    var v = String(value || '').toLowerCase().replace(/\s+/g, '_');
    if (v === 'weekly' || v === 'every-week' || v === 'every_week' || v === '1' || v === '1_week') return 'every_week';
    if (v === 'fortnightly' || v === 'every_2_weeks' || v === 'every-2-weeks' || v === '2' || v === '2_week' || v === '2_weeks') return 'every_2_weeks';
    if (v === '4_weekly' || v === '4_week' || v === '4_weeks' || v === 'every_4_weeks' || v === 'every-4-weeks' || v === 'monthly') return 'every_4_weeks';
    return 'every_week';
  }

  function frequencyLabel(freq) {
    freq = normaliseFrequency(freq);
    if (freq === 'every_2_weeks') return 'Fortnightly';
    if (freq === 'every_4_weeks') return '4 Weekly';
    return 'Weekly';
  }

  function planForTiffin(freq) {
    return TIFFIN.plans[normaliseFrequency(freq)] || TIFFIN.plans.every_week;
  }

  function planForSide(handle, freq) {
    var plans = SIDE_PLANS[handle];
    if (!plans) return null;
    return plans[normaliseFrequency(freq)] || plans.every_week || null;
  }

  function isTiffin(productId, handle) {
    return String(productId || '') === TIFFIN.productId || String(handle || '') === TIFFIN.handle;
  }

  function isKnownSide(handle) {
    return !!SIDE_PLANS[String(handle || '')];
  }

  function planForLine(handle, productId, freq) {
    if (isTiffin(productId, handle)) return planForTiffin(freq);
    return planForSide(handle, freq);
  }

  function parseError(data, fallback) {
    if (!data) return fallback || 'Request failed.';
    if (typeof data === 'string') return data;
    return data.description || data.message || data.error || fallback || 'Request failed.';
  }

  function jsonFetch(url, options) {
    options = options || {};
    options.headers = options.headers || {};
    if (!options.headers.Accept) options.headers.Accept = 'application/json';
    return fetch(url, options).then(function (response) {
      return response.text().then(function (text) {
        var data = {};
        try { data = text ? JSON.parse(text) : {}; } catch (e) { data = { message: text }; }
        if (response.ok) return data;
        data.status = response.status;
        data.description = parseError(data, response.statusText);
        return Promise.reject(data);
      });
    });
  }

  function postJson(path, body) {
    return jsonFetch(endpoint(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function cartAdd(item) {
    var line = {
      id: toInt(item.id),
      quantity: item.quantity || 1,
      properties: item.properties || {}
    };
    var sellingPlan = normalisePlanId(item.selling_plan || item.sellingPlan);
    if (sellingPlan) line.selling_plan = sellingPlan;
    return postJson('cart/add.js', { items: [line] });
  }

  function cartChange(body) {
    body = body || {};
    var outgoing = {};
    Object.keys(body).forEach(function (key) { outgoing[key] = body[key]; });
    if (outgoing.selling_plan !== undefined && outgoing.selling_plan !== null && outgoing.selling_plan !== '') {
      outgoing.selling_plan = normalisePlanId(outgoing.selling_plan);
    }
    return postJson('cart/change.js', outgoing);
  }

  function cartUpdate(attributes) {
    return postJson('cart/update.js', { attributes: attributes || {} });
  }

  function fetchCart() {
    return jsonFetch(endpoint('cart.js'));
  }

  function fetchProduct(handle) {
    return jsonFetch(endpoint('products/' + encodeURIComponent(handle) + '.js'));
  }

  function buildPlanLookup(product) {
    var lookup = {};
    var groups = product && product.selling_plan_groups ? product.selling_plan_groups : [];
    groups.forEach(function (group) {
      var plans = group.selling_plans || [];
      plans.forEach(function (plan) {
        if (!plan || plan.id === undefined || plan.id === null) return;
        lookup[String(plan.id)] = {
          id: toInt(plan.id),
          name: plan.name || plan.title || '',
          description: plan.description || '',
          options: plan.options || [],
          groupId: group.id || group.selling_plan_group_id || null
        };
      });
    });
    return lookup;
  }

  function getAllocationPlanId(allocation) {
    if (!allocation) return null;
    if (allocation.selling_plan_id !== undefined) return toInt(allocation.selling_plan_id);
    if (allocation.selling_plan && allocation.selling_plan.id !== undefined) return toInt(allocation.selling_plan.id);
    if (allocation.id !== undefined && allocation.price !== undefined) return toInt(allocation.id);
    return null;
  }

  function getAllocationPlanName(allocation, plan) {
    if (plan && plan.name) return plan.name;
    if (allocation && allocation.selling_plan && allocation.selling_plan.name) return allocation.selling_plan.name;
    if (allocation && allocation.name) return allocation.name;
    return '';
  }

  function variantPlansFromProduct(product, variantId) {
    var variants = product && product.variants ? product.variants : [];
    var variant = null;
    var targetId = String(variantId || '');
    for (var i = 0; i < variants.length; i += 1) {
      if (String(variants[i].id) === targetId) { variant = variants[i]; break; }
    }
    if (!variant) return [];

    var lookup = buildPlanLookup(product);
    var allocs = variant.selling_plan_allocations || [];
    var plans = [];
    allocs.forEach(function (allocation) {
      var id = getAllocationPlanId(allocation);
      if (!id) return;
      var defined = lookup[String(id)] || null;
      plans.push({
        id: id,
        name: getAllocationPlanName(allocation, defined),
        allocation: allocation,
        definition: defined
      });
    });
    return plans;
  }

  function planMatchesFrequency(plan, freq) {
    var name = String((plan && plan.name) || '').toLowerCase();
    var optionText = '';
    if (plan && plan.definition && plan.definition.options) optionText = JSON.stringify(plan.definition.options).toLowerCase();
    var haystack = name + ' ' + optionText;
    freq = normaliseFrequency(freq);

    if (freq === 'every_2_weeks') return /fortnight|2\s*week|every\s*2/.test(haystack);
    if (freq === 'every_4_weeks') return /4\s*week|four\s*week|every\s*4|monthly/.test(haystack);
    return /(weekly|1\s*week|every\s*week)/.test(haystack) && !/(fortnight|2\s*week|4\s*week|four\s*week|monthly)/.test(haystack);
  }

  function choosePlan(plans, freq, preferredPlanId) {
    var preferred = normalisePlanId(preferredPlanId);
    if (preferred) {
      for (var p = 0; p < plans.length; p += 1) {
        if (String(plans[p].id) === String(preferred)) return plans[p];
      }
    }
    for (var i = 0; i < plans.length; i += 1) {
      if (planMatchesFrequency(plans[i], freq)) return plans[i];
    }
    return plans.length ? plans[0] : null;
  }

  function livePlanFor(handle, variantId, freq, preferredPlanId) {
    if (!handle || !variantId) return Promise.resolve(null);
    return fetchProduct(handle).then(function (product) {
      var plans = variantPlansFromProduct(product, variantId);
      var chosen = choosePlan(plans, freq, preferredPlanId);
      return chosen ? { chosen: chosen, plans: plans, product: product } : { chosen: null, plans: plans, product: product };
    }).catch(function () {
      return { chosen: null, plans: [], product: null };
    });
  }

  function tryPlansSequentially(variantId, quantity, properties, plans, index) {
    if (!plans || index >= plans.length) return Promise.reject({ description: 'No selling plan on this variant was accepted.' });
    return cartAdd({ id: variantId, quantity: quantity, selling_plan: plans[index].id, properties: properties })
      .catch(function () { return tryPlansSequentially(variantId, quantity, properties, plans, index + 1); });
  }

  function addSubscriptionLine(options) {
    options = options || {};
    var variantId = toInt(options.variantId || options.id);
    var quantity = options.quantity || 1;
    var freq = normaliseFrequency(options.frequency);
    var preferred = normalisePlanId(options.planId || options.sellingPlan);
    var handle = options.handle || null;
    var properties = options.properties || {};

    if (!variantId) return Promise.reject({ description: 'No variant ID was supplied.' });
    if (!preferred) preferred = normalisePlanId(planForLine(handle, options.productId, freq));

    if (!preferred) {
      return livePlanFor(handle, variantId, freq, null).then(function (live) {
        if (live.chosen) {
          return cartAdd({ id: variantId, quantity: quantity, selling_plan: live.chosen.id, properties: properties });
        }
        return cartAdd({ id: variantId, quantity: quantity, properties: properties });
      });
    }

    return cartAdd({ id: variantId, quantity: quantity, selling_plan: preferred, properties: properties })
      .catch(function (err) {
        var message = parseError(err).toLowerCase();
        if (!/selling plan|requires a plan|only be purchased/.test(message) && err.status !== 422) throw err;
        return livePlanFor(handle, variantId, freq, preferred).then(function (live) {
          var plans = live.plans || [];
          var remaining = [];
          if (live.chosen && String(live.chosen.id) !== String(preferred)) remaining.push(live.chosen);
          plans.forEach(function (p) {
            if (String(p.id) !== String(preferred) && (!live.chosen || String(p.id) !== String(live.chosen.id))) remaining.push(p);
          });
          if (!remaining.length) throw err;
          return tryPlansSequentially(variantId, quantity, properties, remaining, 0);
        });
      });
  }

  function findCartTiffin(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      if (isTiffin(item.product_id, item.handle || (item.product && item.product.handle))) return item;
    }
    return null;
  }

  function ensureTiffinInCart(options) {
    options = options || {};
    var requestedFreq = normaliseFrequency(options.frequency || 'every_week');
    var requestedDiet = options.diet || 'Vegetarian';

    return fetchCart().then(function (cart) {
      // Every homepage CTA calls this with Vegetarian/weekly hard-coded. If the
      // cart already carries the customer's own choices, those win — otherwise
      // a returning Vegan fortnightly customer clicking the CTA again would have
      // their attributes reset to Vegetarian weekly while the line item kept the
      // vegan variant and the fortnightly plan. The kitchen reads the attribute,
      // so that mismatch means cooking the wrong meal.
      var saved = (cart && cart.attributes) || {};
      var diet = saved.diet_preference || requestedDiet;
      var freq = normaliseFrequency(saved.frequency || requestedFreq);
      var attrs = {
        diet_preference: diet,
        frequency: freq
      };

      var existing = findCartTiffin(cart);
      if (existing) return cartUpdate(attrs);

      // Derive the variant from the diet we settled on, so the line item and the
      // attribute can never disagree.
      var variantId = TIFFIN.variants[diet] || toInt(options.variantId) || TIFFIN.variants.Vegetarian;
      var planId = planForTiffin(freq) || normalisePlanId(options.planId);

      return addSubscriptionLine({
        variantId: variantId,
        handle: TIFFIN.handle,
        productId: TIFFIN.productId,
        planId: planId,
        frequency: freq,
        quantity: 1,
        properties: {
          _role: 'tiffin',
          _diet: diet
        }
      }).then(function () { return cartUpdate(attrs); });
    });
  }

  function updateCartCount(count) {
    var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span:not(.visually-hidden)');
    bubbles.forEach(function (el) { el.textContent = String(count); });
  }

  window.MajahmaSubscriptions = {
    config: { tiffin: TIFFIN, sidePlans: SIDE_PLANS, sideHandles: SIDE_HANDLES },
    endpoint: endpoint,
    toInt: toInt,
    normaliseFrequency: normaliseFrequency,
    normalisePlanId: normalisePlanId,
    frequencyLabel: frequencyLabel,
    planForTiffin: planForTiffin,
    planForSide: planForSide,
    planForLine: planForLine,
    planMatchesFrequency: planMatchesFrequency,
    isTiffin: isTiffin,
    isKnownSide: isKnownSide,
    parseError: parseError,
    cartAdd: cartAdd,
    cartChange: cartChange,
    cartUpdate: cartUpdate,
    fetchCart: fetchCart,
    fetchProduct: fetchProduct,
    variantPlansFromProduct: variantPlansFromProduct,
    livePlanFor: livePlanFor,
    addSubscriptionLine: addSubscriptionLine,
    ensureTiffinInCart: ensureTiffinInCart,
    updateCartCount: updateCartCount
  };
})();
